// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-area-stacked';

export const Component = () => (
  <>
    <path
      fill='currentColor'
      d='m.576 17.424 4.896-3.888c.432-.36 1.08-.576 1.656-.504l3.744.432c.288 0 .576 0 .864-.072l5.76-1.584v5.616H.576V.576z'
    />
    <g stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
      <path d='m.576 17.424 4.896-3.888c.432-.36 1.08-.576 1.656-.504l3.744.432c.288 0 .576 0 .864-.072l5.76-1.584v5.616zm0 0V.576' />
      <path
        fill='currentColor'
        d='M.576 8.424 6.624 5.4c.432-.216 1.008-.288 1.512-.216l3.168.72c.72.144 1.44 0 2.016-.504l4.176-3.744v5.04l-5.76 2.592a1.993 1.993 0 0 1-.936.216H6.84c-.432 0-.792.144-1.152.288L.576 12.96z'
      />
    </g>
  </>
);

export const viewBox = '0 0 18 18';
